import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";
import { aiAssistStep } from "../../utility/aiAssistCopy";

const sections = [
  {
    title: "One game, every pot",
    body: "Enter each game once. The same scores count toward the primary event and the side pots. You do not keep a second sheet for the house.",
  },
  {
    title: "Scratch or handicap",
    body: "Choose Handicap or Scratch for the tournament. Handicap is a percent of the pins under the base, per game, and zero when the average is at or above the base. An optional maximum caps the pins. Scratch scores pinfall. A bowler marked No Average gets zero handicap pins.",
    to: "/bowling-tournament-averages",
    linkLabel: "Averages",
  },
  {
    title: "Equal scores share a place",
    body: "Two teams tied for first both show 1st, and the next score is 3rd. When those places pay, the prize money for the tied places is split evenly.",
  },
  {
    title: "Public standings as you post",
    body: "Standings is a public page. Places update as you post. Prize amounts stay private until you lock results.",
  },
  {
    title: "Read a recap sheet",
    body: "Print recaps for the squad. Import the filled sheet to write the games on the matching team. Review the scores and correct a game if needed.",
    to: "/bowling-tournament-recap-sheet-import",
    linkLabel: "Recap sheet import",
  },
];

const BowlingTournamentScoring = () => (
  <ProductPage
    title="Bowling Tournament Scoring | Bowling Tournament App"
    description="Stop copying the same game onto three side-pot sheets. Enter each game once. Standings update as you post. Bowlers stop crowding the desk for places."
    keywords={[
      "bowling tournament scoring",
      "bowling tournament scoring software",
      "live bowling tournament scores",
      "bowling tournament results",
    ]}
    canonicalUrl="/bowling-tournament-scoring"
    heading="Stop copying one game onto three sheets"
    lede="Enter each game once for the primary event and side pots. Public standings update as you post. Prize amounts wait until you lock results."
    analyticsLocation="bowling_tournament_scoring"
    secondaryTo="/bowling-tournament-payouts"
    secondaryLabel="Payouts"
    sectionHeading="Post once for the weekend"
    sections={sections}
    screenshot={PRODUCT_SCREENSHOTS.scoring}
    importStep={aiAssistStep("recaps")}
  />
);

export default BowlingTournamentScoring;
